import {
  LegalClientSourcesOfIncomeFinancialSourceType,
  LegalClientSourcesOfIncomeSourceType,
} from 'api/types/entity';
import { LegalClientSourcesOfIncomeParam } from 'api/types/params';

import { SourcesOfIncomeFormType } from '../../forms/sourcesOfIncomeForm';

export const getSourcesOfIncomeSubmitData = (
  values: SourcesOfIncomeFormType
): LegalClientSourcesOfIncomeParam => ({
  fileIds: values.sourcesOfIncome.files.map((file) => file.id!),
  financialSources: values.sourcesOfIncome.financialSources.map((v) => v.value),
  incomeSources: values.sourcesOfIncome.incomeSources.map((v) => v.value),

  otherFinancialSource: values.sourcesOfIncome.financialSources.find(
    (v) => v.value === LegalClientSourcesOfIncomeFinancialSourceType.Other
  )
    ? values.sourcesOfIncome.otherFinancialSource
    : undefined,

  otherIncomeSource: values.sourcesOfIncome.incomeSources.find(
    (v) => v.value === LegalClientSourcesOfIncomeSourceType.Other
  )
    ? values.sourcesOfIncome.otherIncomeSource
    : undefined,
});
